import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TuiAccordion } from '@taiga-ui/experimental';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-child-lern',
  standalone: true,
  imports: [TuiAccordion, TranslocoDirective],
  templateUrl: './child-lern.component.html',
  styleUrl: './child-lern.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChildLernComponent {}
